import { useContext } from 'react'
import { OrgAppContext } from '../../context/OrgAppContext';

export const useOrgApp = () => {
  const context = useContext(OrgAppContext);

  if (!context) {
    throw new Error('useOrgApp must be used within a OrgAppProvider')
  }

  return context
}